import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
function MeetDirector({data}:any) {
  return (
    <section className='sp_top meet_director'>
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-md-12">
                    <div className="director_content" dangerouslySetInnerHTML={{ __html: data?.meetDirectorContent || '' }}></div>
                </div>
                <div className="col-lg-7 offset-lg-1 col-md-12">
                    <div className="md_list">
                        {
                            data?.directors && data?.directors.map((director:any,index:any)=>{
                                return(
                                    <div className="md_box" key={index}>
                                        <div className="md_img" data-aos="fade-down" data-aos-delay="100">
                                            <Image src={director?.directorImage?.sourceUrl} alt={director?.directorImage?.altText} width={440} height={517} loading="lazy"/>
                                        </div>
                                        <span className='f24' data-aos="fade" data-aos-delay="200">{director?.directorName}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default MeetDirector